import { QrCode } from "../components/QrCode";
import { BackIcon, PairIcon, ShareIcon, SoloIcon } from "../components/icons";
import { useController, useGame } from "../context";

/**
 * Экран приглашения. Кнопки намеренно разные по виду, чтобы действие читалось без чтения подписи:
 *   «Начать подбор»   — главная: золотая заливка, значок «двое»;
 *   «Поделиться»      — вспомогательная для пары: золотой контур, значок «поделиться»;
 *   «Смотреть одному» — другой режим: нейтральная капсула со значком «один», под разделителем «или»;
 *   «Назад»           — не действие игры, поэтому просто текст со стрелкой.
 */
export function InviteScreen() {
  const controller = useController();
  const session = useGame((s) => s.session);
  const link = controller.inviteLink;
  if (session?.kind !== "room" || !link) return null;

  return (
    <section className="screen">
      <p className="invite-text">
        ID комнаты: <span className="invite-room">{session.id}</span>
      </p>
      <QrCode text={link} />
      <div className="invite-actions" role="group" aria-label="Вдвоём">
        <button
          type="button"
          className="btn btn--outline btn--wide btn--icon"
          onClick={() => controller.share()}
        >
          <ShareIcon />
          Поделиться
        </button>
        <button
          type="button"
          className="btn btn--big btn--wide btn--icon"
          onClick={() => controller.startRoom()}
        >
          <PairIcon />
          {session.mode === "collection" ? "Погнали" : "Начать подбор"}
        </button>
      </div>
      <div className="invite-divider" aria-hidden="true">
        или
      </div>
      <div className="invite-actions">
        <button
          type="button"
          className="btn btn--ghost btn--wide btn--icon"
          onClick={() => void controller.watchSolo()}
        >
          <SoloIcon />
          Смотреть одному
        </button>
        <button
          type="button"
          className="btn btn--link btn--icon"
          onClick={() => controller.goHome()}
        >
          <BackIcon />
          Назад
        </button>
      </div>
    </section>
  );
}
